import { ChangeDetectionStrategy, Component, ElementRef, input, model, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-panel-search',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatIcon, MatIconButton],
  template: `
    <div class="panel-search__wrapper">
      <input
        #searchInput
        class="panel-search__input"
        [ngModel]="query()"
        (ngModelChange)="query.set($event)"
        [placeholder]="placeholder()"
        [attr.aria-label]="placeholder()"
        autocomplete="off"
      />
      <div class="panel-search__icons">
        @if (query()) {
          <button mat-icon-button type="button" (click)="query.set('')" aria-label="Clear search">
            <mat-icon>close</mat-icon>
          </button>
        }
        <button mat-icon-button type="button" class="panel-search__search-button" (click)="focusSearch()" aria-label="Focus search">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>
  `,
  styleUrl: './panel-search.component.scss',
})
export class PanelSearchComponent {
  query = model('');
  placeholder = input('Search...');

  @ViewChild('searchInput') private searchInput?: ElementRef<HTMLInputElement>;

  focusSearch(): void {
    this.searchInput?.nativeElement.focus();
  }
}
